import { queryOptions } from "@tanstack/react-query";
import { currentUser } from "./get-current-user";
import { findUser } from "./get-find-user";
import { findUserById } from "./get-find-user-by-id";
import { userModules } from "./get-user-modules";

export const userQueries = {
  rootKey: () => ["user"],

  modules: () =>
    queryOptions({
      queryKey: [...userQueries.rootKey(), "modules"],
      queryFn: () => userModules(),
    }),

  currentUser: () =>
    queryOptions({
      queryKey: [...userQueries.rootKey(), "currentUser"],
      queryFn: () => currentUser(),
    }),

  findByEmail: ({
    email,
    companyIds,
  }: {
    email: string;
    companyIds: string[];
  }) =>
    queryOptions({
      queryKey: [...userQueries.rootKey(), "findByEmail", email],
      queryFn: () => findUser({ email, companyIds }),
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    }),

  userContact: (userId: string) =>
    queryOptions({
      queryKey: [...userQueries.rootKey(), "contact", userId],
      queryFn: () => findUserById(userId),
    }),
};
